import type { DetailedFuelFilling } from '@/generated/model';

import type { RefuelsDateRange } from '../types/RefuelsDateRange.types';
import type { RefuelsResult } from '../types/RefuelsResult.types';

export function getRefuelsResult(
  refuels: DetailedFuelFilling[] | undefined,
  dates: RefuelsDateRange | undefined
): RefuelsResult | undefined {
  if (!refuels || !dates) {
    return undefined;
  }

  return { refuels, dates };
}
